module.exports = __webpack_public_path__ + "img/fwsrz.1e39db75.png";